import script from "./AppMixin.vue?vue&type=script&lang=ts"
export * from "./AppMixin.vue?vue&type=script&lang=ts"

export default script